import { Loading } from '../../../common/loading'
import { Notification } from '../../../common/notification'

export const PANEL_MIN_HEIGHT = 310

const withLoadingFeedBack =
  (Component) =>
  ({ isLoading, data, height, ...other }) => {
    if (isLoading) {
      return (
        <div
          className="positionRelative"
          style={{ height: height || PANEL_MIN_HEIGHT }}
        >
          <Loading />
        </div>
      )
    }

    if (!data.length) {
      return (
        <div
          className="positionRelative"
          style={{ height: height || PANEL_MIN_HEIGHT }}
        >
          <Notification />
        </div>
      )
    }

    return <Component {...other} />
  }

export default withLoadingFeedBack
